import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  public rolesLoading = false;
  public Roles = new Roles();
  public Roles$ = new ReplaySubject(1);

  constructor(
    private http: HttpClient
  ) {
  }

  initRoles() {
    if (!this.rolesLoading) {
      this.rolesLoading = true;
      this.http.get('auth/roles')
        .finally(() => this.rolesLoading = false)
        .subscribe((roles: any) => {
          this.Roles.roles = roles;
          this.publishRoles();
        });
    }
  }

  publishRoles() {
    this.Roles$.next(this.Roles);
  }


}

export class Roles {
  public roles = [];

  hasAnyRoles(roles: string[]) {
    let hasRoles = roles.filter((role) => {
      return this.roles.indexOf(role) !== -1;
    })
    return hasRoles.length > 0
  }
}
